import { Navigate } from "react-router-dom";
import { Clock, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/lib/api";
import AdminPortal from "@/pages/portals/AdminPortal";
import SponsorPortal from "@/pages/portals/SponsorPortal";
import FencePortal from "@/pages/portals/FencePortal";
import ProviderPortal from "@/pages/portals/ProviderPortal";
import VolunteerPortal from "@/pages/portals/VolunteerPortal";

const MAP = { admin: AdminPortal, sponsor: SponsorPortal, fence_partner: FencePortal, swim_provider: ProviderPortal, volunteer: VolunteerPortal };

export default function Portal() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="p-20 text-center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  const View = MAP[user.role];
  return (
    <div className="min-h-[80vh]" data-testid="portal-page">
      <div className="bg-[#03045E] text-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 flex flex-wrap gap-4 justify-between items-end">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-sky-300 font-bold" data-testid="portal-role">{ROLE_LABEL[user.role]} Portal</p>
            <h1 className="font-display uppercase text-3xl sm:text-4xl mt-1" data-testid="portal-name">{user.org_name || user.name}</h1>
          </div>
          <button onClick={logout} className="rounded-full border border-white/30 px-4 py-2 text-sm font-bold flex items-center gap-2 hover:bg-white/10" data-testid="portal-logout-button"><LogOut className="w-4 h-4" /> Sign out</button>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        {user.role !== "admin" && !user.approved ? (
          <div className="rounded-3xl bg-white border border-sky-100 p-10 text-center" data-testid="portal-pending">
            <Clock className="w-12 h-12 text-[#FF6B35] mx-auto" />
            <p className="font-display uppercase text-2xl text-[#03045E] mt-3">Account pending approval</p>
            <p className="text-slate-600 mt-2">A Swim for Rakim administrator will review your account. You'll get full portal access once approved.</p>
          </div>
        ) : <View user={user} />}
      </div>
    </div>
  );
}
